import api from "./api";

interface RawPublishersResponse {
  publishingHouses?: {
    id: string;
    name: string;
    logoUrl?: string;
    revenuePercent?: number;
  }[];
}

export interface PublisherOption {
  id: string;
  name: string;
  revenuePercent: number;
  logoUrl: string;
}

/** All publishing houses for the superadmin filter (incl. revenuePercent). */
export async function getPublishers(): Promise<PublisherOption[]> {
  const data = await api.get<unknown, RawPublishersResponse>("/publishers", {
    params: { fetchAll: true },
  });
  return (data?.publishingHouses ?? [])
    .map((p) => ({
      id: p.id,
      name: p.name,
      revenuePercent: p.revenuePercent ?? 1,
      logoUrl: p.logoUrl ?? "",
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
